import(/* webpackMode: "eager" */ "/netflix-clone/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["SentryProvider"] */ "/netflix-clone/components/sentry-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/netflix-clone/components/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/netflix-clone/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TooltipProvider"] */ "/netflix-clone/components/ui/tooltip.tsx");
